import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

export const TOKEN_KEY = 'jwtToken';

export interface AuthState {
  token: string | null;
}

const initialState: AuthState = {
  token: localStorage.getItem(TOKEN_KEY),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      if(!action.payload) {
        localStorage.removeItem(TOKEN_KEY);
      }
      localStorage.setItem(TOKEN_KEY, action.payload);
      state.token = action.payload;
    },
  },
});

export const {
  setToken,
} = authSlice.actions;

export default authSlice.reducer;
